import type ApiRequestOptions from '../api-request/ApiRequestOptions';
import type ApiClientResponseInterceptor from './api-client-interceptors/ApiClientResponseInterceptor';
import type ApiClient from './ApiClient';

import { without } from 'lodash-es';

import ApiRequestMethod from '../api-request/ApiRequestMethod';
import createAxiosInstance from './api-client-request/createAxiosInstance';
import requestViaAxios from './api-client-request/requestViaAxios';

export default function createApiClient(clientOptions?: { baseUrl: string }): ApiClient {
  const axiosInstance = createAxiosInstance();

  let responseInterceptors: ApiClientResponseInterceptor[] = [];

  const request = async (url: string, options: ApiRequestOptions) =>
    requestViaAxios(axiosInstance, url, {
      ...options,
      baseUrl: clientOptions?.baseUrl,
      responseInterceptors,
    });

  return {
    delete: async (url, options) => {
      return request(url, {
        method: options?.method ?? ApiRequestMethod.DELETE,
        ...options,
      });
    },
    get: async (url, options) => {
      return request(url, {
        method: options?.method ?? ApiRequestMethod.GET,
        ...options,
      });
    },
    getBaseUrl: () => clientOptions?.baseUrl ?? null,
    patch: async (url, options) => {
      return request(url, {
        method: options?.method ?? ApiRequestMethod.PATCH,
        ...options,
      });
    },
    post: async (url, options) => {
      return request(url, {
        method: options?.method ?? ApiRequestMethod.POST,
        ...options,
      });
    },
    put: async (url, options) => {
      return request(url, {
        method: options?.method ?? ApiRequestMethod.PUT,
        ...options,
      });
    },
    request: async (url, options) => {
      return request(url, options ?? {});
    },
    useResponseInterceptor: (interceptor) => {
      responseInterceptors = [...responseInterceptors, interceptor];

      return () => {
        responseInterceptors = without(responseInterceptors, interceptor);
      };
    },
  };
}
